import React from 'react'
import Image from '../../../images/sellerpolicies/3.png'

const Commission_structure = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>COMMISSION Structure</h2>
            <p>Following Is the Rate of commission KAAY will charge upon the sale of the product on KAAY’s platform unless specified otherwise in any special terms agreed upon:</p>
            <table>
                <tr>
                    <th>Segment</th>
                    <th>Sub-Segment</th>
                    <th>REGISTERED AS</th>
                    <th>Rate of Commission %</th>
                </tr>
                <tr>
                    <th rowSpan={2}>BUSINESS TO CUSTOMER (B2C)<br></br>(NEW ON KAAY)</th>
                    <th>FASHIONWEAR AND ACCESSORIES </th>
                    <td>BUSINESS</td>
                    <td>12%</td>
                </tr>
                <tr>
                    <th>ART AND LIFESTYLE</th>
                    <td>BUSINESS</td>
                    <td>12%</td>
                </tr>
                <tr>
                    <th rowSpan={2}>CUSTOMER-TO-CUSTOMER (C2C)<br></br>(KAAY CLOSET)</th>
                    <th>NEW</th>
                    <td>USER</td>
                    <td>15%</td>
                </tr>
                <tr>
                    <th>PRELOVED</th>
                    <td>USER</td>
                    <td>15%</td>
                </tr>
                <tr>
                    <th>WHOLESALE</th>
                    <th>WHOLESALE</th>
                    <td>WHOLESALE</td>
                    <td>5%</td>
                </tr>
            </table>
            <p>Commissions are calculated on the gross amount of the product.</p>
            <p>KAAY will deduct the commission at the time of making payouts to the Seller upon the sale of the product. Payment terms and conditions are defined in the Payment policy.</p>
            <p>KAAY reserve the right to change the structure of the percentage of commission rate with the prior 15 days’ notice and to the sellers. Notice can be provided digitally or physically.</p>
        </div>
      </div>
    </div>
  )
}

export default Commission_structure
